import React from 'react';
import { motion } from 'framer-motion';
import { Radio, QrCode, BarChart2, Trophy, Database } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const stepIcons = [Radio, QrCode, BarChart2, Trophy, Database];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: 'easeOut', delay },
});

export default function ROI() {
  const { t } = useLanguage();
  const r = t.roi;

  return (
    <section className="py-14 md:py-20 bg-[#1A222B]" data-testid="roi-section">
      <div className="section-container">
        <motion.div className="text-center mb-14" {...fadeUp()}>
          <div className="divider-gold mx-auto" />
          <h2 className="heading-lg">
            {r.title}<br />
            <span className="text-gradient-gold">{r.titleHighlight}</span>
          </h2>
          <p className="text-[#8A9099] text-base mt-4 max-w-xl mx-auto">{r.body}</p>
        </motion.div>

        {/* Cycle */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-12">
          {r.steps.map((step, i) => {
            const Icon = stepIcons[i];
            return (
              <motion.div key={i} className="relative flex flex-col items-center text-center" {...fadeUp(0.1 + i * 0.1)}
                data-testid={`roi-step-${i}`}>
                {/* Connector (desktop) */}
                {i < r.steps.length - 1 && (
                  <div className="hidden lg:block absolute top-8 left-[calc(50%+2.5rem)] right-0 h-px bg-gradient-to-r from-[#D5A63B]/40 to-transparent" />
                )}
                <div className="w-16 h-16 rounded-full bg-[#171E26] border-2 border-[#D5A63B]/40
                  flex flex-col items-center justify-center mb-4 shadow-[0_0_16px_rgba(213,166,59,0.1)]
                  hover:border-[#D5A63B]/80 hover:shadow-[0_0_24px_rgba(213,166,59,0.25)] transition-all duration-300">
                  <span className="text-[#D5A63B]/60 text-[9px] font-black font-exo">{step.num}</span>
                  <Icon size={18} className="text-[#D5A63B]" />
                </div>
                <h3 className="font-exo font-bold italic text-[#F3F1EB] text-sm mb-1.5">{step.title}</h3>
                <p className="text-[#8A9099] text-xs leading-relaxed">{step.desc}</p>
              </motion.div>
            );
          })}
        </div>

        {/* Headline */}
        <motion.div className="text-center bg-gradient-to-r from-[#0F6B49]/20 via-[#D5A63B]/10 to-[#0F6B49]/20
          border border-[#D5A63B]/20 rounded-2xl py-8 px-6" {...fadeUp(0.6)}>
          <p className="heading-lg text-gradient-gold">{r.headline}</p>
        </motion.div>
      </div>
    </section>
  );
}
